import {FC, ReactNode} from "react"
import cn from "classnames"

interface BlockProps {
  className?: string
  children: ReactNode
}

export const Block: FC<BlockProps> = ({children, className}) => (
  <div className={cn("mx-auto px-5 max-w-tablet-frame tablet:px-0", className)}>
    {children}
  </div>
)
